import {Get,Post,$Http, ua} from '@kkmh/utils';
import {getPayInfo} from "./utils";
const formatApiRes = (res) => {
    let result = {};
    if (!res.code) {
        result = res.data;
    } else {
        result = res;    
    }
    return {
        code : result.code || 0,
        data : result.data || {},
        message : result.message || '',
    }
}
const formatApiResError = (error) => {
    return {code:-1,data:{},message:error};
}
//获取userme
export const getUserMe = (opt) => {
    return new Promise(resolve => {
        let url         = 'v2/passport/user/me';
        let yapimockurl = '';
        let data        = {};
        request('get', resolve, {url, yapimockurl, data}, opt)
    })
}
/*----------VIP--------------*/
//获取列表vip-native
export const getH5Membergoods = (opt) => {

    return new Promise(resolve => {
        let url         = 'v1/vip/member_good/list_h5';
        var yapimockurl = 'https://yapi.quickcan.com/mock/341/v1/vip/member_good/list_h5?name=yingxiaoquyu';
        var yapimockurl = 'https://yapi.quickcan.com/mock/341/v1/vip/member_good/list_h5?name=tianjianglibao';
        let data        = {
            third_activity              : opt.third_activity || '',
            non_iap_supported_device    : opt.non_iap_supported_device || false,//是否越狱设备，true表示是
            non_iap_supported           : opt.non_iap_supported || 0,//运营位是否支持越狱，1表示支持
            compel_iap                  : opt.compel_iap || false,//什么场景传递?勾选越狱商品选择用iap支付时传递true下发iap商品
            platform                    : opt.platform || 3, //1：安卓，2：ios，3：H5，优先取platform，如果platform没传，就按userAgent取
            pay_info                    : getPayInfo(opt) || {},
        }
        request('get', resolve, {url, yapimockurl, data}, opt)
    })
}
//获取列表vip-browser
export const getH5MembergoodsBrowser = (opt) => {
    return new Promise(resolve => {
        let url         = 'v1/pay/member_good/h5_list';
        let yapimockurl = '';
        let data        = {
            third_activity  : opt.third_activity || '',
            code            : opt.code || '',//微信登录校验code
            // origin_url      : opt.origin_url || '',//来源url
            env             : opt.env || '', //切环境参数
            time            : new Date().getTime(),//后退页面可以刷新接口
        } 
        request('get', resolve, {url, yapimockurl, data})
    })
}
//获取vip-detail (调用场景-端外为了获取支付方式)
export const getH5Memberdetail = (opt) => {
    return new Promise(resolve => {
        let url         = 'v1/vip/member_good/detail';
        let yapimockurl = '';
        let data        = {
            third_activity              : opt.third_activity,
            good_id                     : opt.good_id,
            non_iap_supported_device    : opt.non_iap_supported_device || false,//是否越狱设备，true表示是
            non_iap_supported           : opt.non_iap_supported || 0,//运营位是否支持越狱，1表示支持
        } 
        request('get', resolve, {url, yapimockurl, data}, opt)
    })
}
//定向限免-vip-注册赠送话数
export const freeCalculate = (opt) => {
    return new Promise(resolve => {
        let url         = 'v2/comicbuy/free/calculate';
        let yapimockurl = 'https://yapi.quickcan.com/mock/317/v2/comicbuy/free/calculate?name=tianjianglibao';
        let data        = {
            activity_name   : opt.third_activity || '',
            combo_list      : opt.combo_list || '',
            topic_id        : opt.topic_id || 0,
            comic_id        : opt.comic_id || 0,
            get_right_now   : opt.get_right_now || false,
            source_type     : opt.source_type || '',
        };
        request('post', resolve, {url, yapimockurl, data}, opt)
    })
}
//定向限免-vip-注册赠送话数
export const freeAssignH5 = (opt, free_encrypt_str) => {
    return new Promise(resolve => {
        let url         = '/v2/comicbuy/free/assign_h5';
        let yapimockurl = 'https://yapi.quickcan.com/mock/317/v2/comicbuy/free/assign_h5';
        let data        = {
            free_encrypt_str: free_encrypt_str || '',
            topic_id        : opt.topic_id || 0,
            comic_id        : opt.comic_id || 0,
        };
        let method = "post";
        let dataType = "json";
        request('post', resolve, {url, yapimockurl, data}, opt)
    })
}
//福利信息接口（购买后）游戏组需要：
export const orderMarketing = (opt) => {
    return new Promise(resolve => {
        let url         = 'v1/pay/pay_order/query/detail_order_marketing';
        let yapimockurl = '';
        let data        = {
            order_id : '',
        };
        request('get', resolve, {url, yapimockurl, data}, opt)
    })
}
//打开时上报接口（计时10分钟是否开通逻辑）
export const delayAddH5 = (opt) => {
    return new Promise(resolve => {
        let url         = 'v1/fox/behavior/delay_add_h5';
        let yapimockurl = '';
        let data        = {
            exit_open_vip : 1, //退出会员开通页 （打开会员半屏页时请求）
            exit_open_kkb : 0, //退出充值中心页（打开kkb充值半屏页时请求）
        };
        request('post', resolve, {url, yapimockurl, data}, opt)
    })
}
//获取埋点信息
export const getHeladike = (opt) => {
    return new Promise(resolve => {
        let url         = 'v1/fox/horadric/pay';
        let yapimockurl = '';
        let data        = {
            data_types : '1,2,3,4,5', //kkb_common: 1 kk币公共埋点数据,vip_common: 2 用户会员身份公共埋点数据,comic_buy_common: 3 用户漫画购买公共埋点数据,comic_pay_common:4 漫画付费状态相关公共埋点数据,pay_user_common:5 付费用户身份相关公共埋点数据
            topic_id : opt.topic_id || 0,//144, 
            comic_id : opt.comic_id || 0,//9340,
        };
        request('get', resolve, {url, yapimockurl, data}, opt)
    })
}
//获取topic，comic名称也是用于埋点所需：
export const getTopic = (opt) => {
    return new Promise(resolve => {
        let url         = 'v2/kb/point/charge_h5';
        let yapimockurl = '';
        let data        = {
            charge_time_idx : 0, //需要获取最近第N次付款 默认1表示最近一次
            topic_id : opt.topic_id || 0,//144, 
            comic_id : opt.comic_id || 0,//9340,
        };
        request('get', resolve, {url, yapimockurl, data}, opt)
    })
}



/*----------KKB--------------*/
//获取列表kkb-native
export const getH5Rechargegoods = (opt) => {
    return new Promise(resolve => {
        let url         = 'v1/pay/recharge_good/list_h5';
        let yapimockurl = 'https://yapi.quickcan.com/mock/311/v1/pay/recharge_good/list_h5?name=华为';
        let data        = {
            third_activity              : opt.third_activity || '',
            from                        : opt.from || 1, //投放载体，端内APP：1 M站：5
            topic_id                    : opt.topic_id || 0,//来源专题id
            non_iap_supported_device    : opt.non_iap_supported_device || false,//是否越狱设备，true表示是
            non_iap_supported           : opt.non_iap_supported || 0,//运营位是否支持越狱，1表示支持
        }
        request('get', resolve, {url, yapimockurl, data}, opt)
    })
}
//获取列表kkb-browser
export const getH5RechargegoodsBrowser = (opt) => {
    // from: 微信3 qq4 百度8  快手12  支付宝9 夸克14 UC13 M站5
    var from = 5;
    if (ua['wechatmini']) from = 3;
    if (ua['qqmini'])  from = 4;
    if (ua['baidumini'])  from = 8;
    if (ua['alipaymini'])  from = 9;
    if (ua['kuaishoumini'])  from = 12;
    if(ua['quarkmini']) from = 14;
    if(ua['ucmini']) from = 13;
    return new Promise(resolve => {
        let url         = 'v1/pay/recharge_good/h5_list';
        let yapimockurl = '';
        let data        = {
            third_activity  : opt.third_activity || '',
            code            : opt.code || '',//微信登录校验code
            origin_url      : opt.origin_url || '',//来源url
            topic_id        : opt.topic_id || 0,//来源专题id
            env             : opt.env || '', //切环境参数
            time            : new Date().getTime(),//后退页面可以刷新接口
            from            : from
        } 
        request('get', resolve, {url, yapimockurl, data})
    })
}
//获取kkb-detail
export const getH5Rechargedetail = (opt) => {
    return new Promise(resolve => {
        let url         = 'v1/pay/recharge_good/detail';
        let yapimockurl = '';
        let data        = {
            good_id : opt.good_id || 0,
            non_iap_supported_device    : opt.non_iap_supported_device || false,//是否越狱设备，true表示是
        }
        request('get', resolve, {url, yapimockurl, data}, opt)
    })
}
const getHeaders = (opt={}) => {
    return {
        "X-Device"      : opt.device_id || '',
        "Muid"          : opt.muid || '',
        "App-Info"      : opt.app_info || '',
        "Package-Id"    : opt.package_id || '',
    }
}
const request = (method, resolve, param, opt) => {
    param.headers = getHeaders(opt);
    if (method == 'post') {
        Post(param).then(res => {
            resolve(formatApiRes(res));
        }).catch(error => {
            resolve(formatApiResError(error));
        });
    } 
    if (method == 'get') {
        Get(param).then(res => {
            resolve(formatApiRes(res));
        }).catch(error => {
            resolve(formatApiResError(error));
        });
    }
}


/**
 * postAccumReceive 多充多送: 领取奖励
 * @author zhilichao
 * @yapi   https://yapi.quickcan.com/project/347/interface/api/4431 袁鑫|于文博
 * @param  accum_level_id  奖励id[必传参数]
 * @param  activity_id     活动id[必传参数]
 * @retrun Promise
 * **/ 
export const postAccumReceive = (opt) => {
    // from: 微信3 qq4 百度8  快手12  支付宝9 夸克14 UC13 M站5
    var from = 5;
    if (ua['wechatmini']) from = 3;
    if (ua['qqmini'])  from = 4;
    if (ua['baidumini'])  from = 8;
    if (ua['alipaymini'])  from = 9;
    if (ua['kuaishoumini'])  from = 12;
    if (ua['quarkmini']) from = 14;
    if (ua['ucmini']) from = 13;

    return new Promise(resolve => {
        let url         = 'v2/kb/accum_activity/receive';
        let yapimockurl = '';
        let data        = {
            accum_level_id : opt.accum_level_id || "",
            activity_id    : opt.activity_id || "",//是否越狱设备，true表示是
        }
        if (!ua.kkmh){
            data.from = from;
        }
        request('post', resolve, {url, yapimockurl, data}, opt);
    })
};

const apiserver = {
    getH5Membergoods,
    getH5Memberdetail,
    postAccumReceive
}
export default apiserver



// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/assets/api.js